export enum SignOrder {
  FIRST = 'first',
  LAST = 'last'
}
